/* eslint-disable */
import { shape, string, number, arrayOf, oneOfType, func, bool } from 'prop-types';

import { stringOrNumberPropTypes } from '~utils/propTypes';

export const addressPropTypes = shape({
  textAddress: string,
  apartmentDetails: string,
  kind: string,
  dispatchNote: string,
  latitude: stringOrNumberPropTypes,
  longitude: stringOrNumberPropTypes
});

export const addressStorePropTypes = shape({
  business_hours: arrayOf(
    shape({
      id: number,
      day: string,
      closing_time: string,
      opening_time: string
    })
  ),
  commune: string,
  delivery_open: bool,
  delivery_wait_time: number,
  future_orders_enabled: bool,
  id: number,
  latitude: number,
  longitude: number,
  menu_id: number,
  name: string,
  order_method: string,
  payment_code: string,
  payment_methods: { cash: bool, credit: bool, web_online: bool },
  phone: string,
  pick_up_open: bool,
  pick_up_wait_time: number,
  region: string,
  sodexo_id: bool,
  text_address: string,
  zendesk_id: string
});

export const addressProfilePropTypes = arrayOf(addressPropTypes);

export const userAddProptypes = shape({
  value: string,
  position: number
});

export const addressComponentPropTypes = shape({
  longName: string,
  shortName: string,
  types: arrayOf(string)
});

export const addressLocationPropTypes = shape({
  lat: oneOfType([func, string, number]).isRequired,
  lng: oneOfType([func, string, number]).isRequired
});

export const addressGeometryPropTypes = shape({
  location: addressLocationPropTypes,
  locationType: string,
  viewport: shape()
});

export const googleAddressPropTypes = shape({
  addressComponents: arrayOf(addressComponentPropTypes),
  formattedAddress: string,
  geometry: addressGeometryPropTypes,
  placeId: string,
  types: arrayOf(string)
});
